import type { ESharingState } from "app/components/sharingAssetModal/types";

export enum ECategoryType {
    GENERAL_LIST = "General",
    PARTNERS_LIST = "PartnersList",
    MARKET_LIST = "Market",
}

export interface ICategory {
    id: CategoryId;
    text: string;
    getText?(): string;
    icon: string;
    cssClass: string;
    inactive: boolean;
    isCustomCategory: boolean;
    isOldCategory?: boolean;
    Sons?: any;
    children?: any;
    name?: string;
    sons?: any;
    domains?: string[];
    categoryHash?: string;
    categoryId: string;
    uniqueId?: string;
    categoryType?: ECategoryType;
    forApi: string;
    forUrl: string;
    forDisplayApi: string;
    isShared?: boolean;
    country?: number;
    sharingState?: ESharingState;
    sharedWithUsers?: Array<number>;
    sharedWithAccounts?: Array<number>;
    addedTime?: string; // example "2021-07-01T07:45:51"
    lastUpdated: string; // example "2021-07-01"
    segments?: string[];
    segmentGroupId?: string;
}
export interface ICustomCategory extends ICategory {
    editable: boolean;
    deletable: boolean;
    isShared?: boolean;
}
export type ICategories = Array<ICategory>;
export type CategorySearchKey = keyof ICategory;

/**
 * Same as ICategory, but assuming that all categories have been flatened,
 * therefore each category has no nested children, but will specify these details
 * with "isChild" and "parentItem" properties.
 */
export interface IFlattenedCategory extends ICategory {
    isChild: boolean;
    parentItem?: IFlattenedCategory;
}

export type CategoryId = string;
